module.exports = __webpack_public_path__ + "SP_SPS8-AfterSchool-07eb8cb61682b89e4f8d3a161cd075f2.png";